import type { PaletteColor } from "@brexhq/metal-foundation";
import React from "react";

import { Text } from "@brexhq/shared/components/Typography/Text";
import { MarginOptions } from "@brexhq/shared/components/Typography/types";
import spacing from "@brexhq/shared/styles/spacing";

const DefaultMargins = {
  LRG: [spacing.m16, 0, 0, 0],
  MED: [spacing.m16, 0, 0, 0],
  SML: [spacing.m16, 0, 0, 0],
};
const MediaCaption = ({
  caption,
  textColor,
  margin = DefaultMargins,
}: {
  caption: string;
  textColor: PaletteColor;
  margin?: MarginOptions;
}) => (
  <Text
    as="figcaption"
    color={textColor}
    components={{
      LRG: "Caption",
      MED: "Caption",
      SML: "Caption",
    }}
    margin={margin}
  >
    {caption}
  </Text>
);

export default MediaCaption;
